import { combineReducers, configureStore } from "@reduxjs/toolkit";
import navReducer from "./slices/navSlice";
import authReducer from "./slices/authSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import storeReducer from "./slices/storeSlice";
import referralReducer from "./slices/referralSlice";
import productReducer from "./slices/productSlice";
import sourcingRequestReducer from "./slices/sourcingRequestSlice";
import orderReducer from "./slices/orderSlice";
import orderTrackingReducer from "./slices/orderTrackingSlice";
import transactionReducer from "./slices/transactionSlice";
import notificationReducer from "./slices/notificationSlice";
import walletReducer from "./slices/walletSlice";
import shippingReducer from "./slices/shippingSlice";

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["orderTracking", "transaction", "shipping", "product", "order"],
};
const reducers = combineReducers({
  nav: navReducer,
  auth: authReducer,
  store: storeReducer,
  referral: referralReducer,
  product: productReducer,
  sourcingRequest: sourcingRequestReducer,
  order: orderReducer,
  orderTracking: orderTrackingReducer,
  wallet: walletReducer,
  transaction: transactionReducer,
  notification: notificationReducer,
  shipping: shippingReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
